import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import configs from "config"
const { Url, apiVersion } = configs.client
import { useParams } from "react-router-dom"
import axios from "axios"
import moment from "moment"
import CustomSpinner from "components/Common/CustomSpinner"
import UnAuthorizedPopup from "components/Common/UnAuthorized/UnAuthorizedPopup"
import { unAuthUser } from "store/actions"

import { toast } from "react-toastify"

function TicketComplaintLog({ ticketLogFromSocket }) {
  const { access, authorized } = useSelector(state => ({
    access: state.Login?.userAccess,
    authorized: state.Login.authorized,
  }))

  const [ticketLogData, setTicketLogData] = useState(ticketLogFromSocket || [])
  const [loadingTicketLog, setLoadingTicketLog] = useState(true)

  const params = useParams()
  const dispatch = useDispatch()

  const fetchTicketLog = () => {
    axios
      .get(
        `${Url}/${apiVersion}/tickets/${params.ticketId}/ticket-logs/complaint`,
        {
          headers: {
            Authorization: `Bearer ${access}`,
          },
        }
      )
      .then(res => {
        setLoadingTicketLog(false)
        setTicketLogData(res.data.data.ticketLogs)
      })
      .catch(err => {
        setLoadingTicketLog(false)

        if (err?.response?.status === 401) {
          dispatch(unAuthUser())
        } else {
          toast.error("Failed to fetch complaint logs. Please try again.")
          console.log(err)
        }
      })
  }

  useEffect(() => {
    fetchTicketLog()
  }, [])

  useEffect(() => {
    if (ticketLogFromSocket && ticketLogFromSocket.length) {
      setTicketLogData(ticketLogFromSocket)
      setLoadingTicketLog(false)
    }
  }, [ticketLogFromSocket])

  const formatLog = log => {
    const title = log.actionEN || log.actionAR || log.action_en || log.action_ar
    const description = log.descriptionEN || log.descriptionAR
    const by = log.by
    const dateValue = log.createdAt
    const formattedDate = dateValue
      ? moment(dateValue).format("DD MMMM YYYY hh:mm A")
      : ""

    if (!title && !description && !by) {
      return null
    }

    return {
      title,
      description,
      by,
      clientName: log.clientName,
      date: formattedDate,
    }
  }

  if (!authorized) {
    return <UnAuthorizedPopup />
  }

  return (
    <div
      style={{
        height: "calc(-6px + 77vh)",
        maxHeight: "calc(-6px + 77vh)",
        overflow: "auto",
        padding: "16px",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        backgroundColor: "#fff",
      }}
    >
      {loadingTicketLog ? (
        <CustomSpinner />
      ) : (
        ticketLogData.map((log, index) => {
          const formattedLog = formatLog(log)
          return (
            formattedLog && (
              <div key={index} className="mb-4">
                <div className="d-flex justify-content-between">
                  <h6
                    className="text-black mb-1"
                    style={{ fontWeight: "bold" }}
                  >
                    {formattedLog.title}
                  </h6>
                  <small className="text-muted">{formattedLog.date}</small>
                </div>

                {formattedLog.description && (
                  <p className="mb-1">{formattedLog.description}</p>
                )}

                {(formattedLog.by || formattedLog.clientName) && (
                  <div className="d-flex justify-content-between gap-2">
                    <small className="text-muted">
                      {formattedLog.by ? `By: ${formattedLog.by}` : ""}
                    </small>

                    <small className="text-muted">
                      {formattedLog.clientName
                        ? `Client: ${formattedLog.clientName}`
                        : ""}
                    </small>
                  </div>
                )}
                <hr className="my-3" />
              </div>
            )
          )
        })
      )}
    </div>
  )
}

export default TicketComplaintLog
